<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="1"></titled>
    <span class="apphome">
      <el-tabs v-model="activeName" type="border-card" style="width: 100%;" @tab-click="handleClick">
        <el-tab-pane label="趋势" name="first">
          <div class="search">
            <span>
              <div class="name">时间段</div>
              <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
            <span style="margin-left:20px">
              <div class="name">变量类型</div>
              <!-- <div class="p" style="line-height: 34px;margin-left: 20px;">0 选择</div> -->
              <el-select v-model="variableValue" placeholder="请选择">
                <el-option v-for="item in variableOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
             <span style="margin-left: 30px;">
              <div class="name"></div>
              <div class="p">
                <el-button type="primary" @click="getList">查询</el-button>
              </div>
            </span>
            <!-- <span style="margin-left: auto;">
              <div class="name"></div>
              <div class="p">
                <el-button type="primary">增加参数</el-button>
              </div>
            </span> -->
          </div>
          <div class="echart">
            <vchart style="height: 380px;width:100%;" ref='vchart'></vchart>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电流温度曲线" name="second">
          <div class="search">
            <span>
              <div class="name">时间段</div>
              <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
            <!-- <span style="margin-left: 30px;">
              <div class="name">输入</div>
              <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
            <span style="margin-left: 30px;">
              <div class="name">输入</div>
              <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span> -->

          </div>
          <div class="echart">
            <vchart style="height: 380px;width:168vh ;" ref='vchart2'></vchart>
          </div>
        </el-tab-pane>
      </el-tabs>
    </span>
  </div>
</template>
<script>

  import titled from '@/components/module/titled/titled.vue';
  import vchart from '@/components/module/chart/vchart.vue'
  import {findCurve} from "../../api/maintain";
  export default {
    components: {
      titled,
      vchart
    },
    data() {

      return {
         nowDevice:{},//当前设备
        dayOption: {
          legend: {
            right: '1%',
          },
          grid: {
            // 距离 上右下左 的距离
            left: '5%',
            right: '5%',
            bottom: '8%',
            top: '12%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            name: '电流（A）温度（℃）',
            nameTextStyle: {
              fontSize: 15,
              padding: [0, 0, 0, 70],
              color: '#999',
              rich: {
                a: {
                  // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                }
              }
            },
            axisLine: {
              show: true,
            },
            type: 'value'
          },
          series: [
            {
              name: '懒得看哦了k',
              data: [100, 230, 224, 218, 135, 147, 260],
              type: 'line'
            },
            {
              name: 'IL2',
              data: [150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            },
            {
              name: 'IL3',
              data: [150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            }
          ]
        },
        activeName: 'first',
        options: [{
          value: 'DAY',
          label: '日'
        }, {
          value: 'MON',
          label: '月'
        }, {
          value: 'YEAR',
          label: '年'
        }],
        variableOption:[{
          value: 'ELECTRICITY',
          label: '电流'
        }, {
          value: 'TEMPERATURE',
          label: '温度'
        }],
          value: 'DAY',
        variableValue:"ELECTRICITY",
         dayData: [],
        monthData: [],
        yearData: [],
      }
    },
    computed: {
      setDeviceItem(){ 
				return this.$store.cacheStore.state.setDevice
			},
		},
    watch: {
      setDeviceItem:function(val){
        this.nowDevice = val
        this.getList()
			},
		
		},

    mounted() {
      for (let i = 1; i <= 31; i++) {
        if (i <= 24) {
          this.dayData.push(i > 9? i+':00': '0'+i+':00')
        }
        if (i <= 12) {
          this.yearData.push(i + '月')
        }
        this.monthData.push(i+'号');
      }
      this.dayOption.xAxis.data = this.dayData;
      this.$refs.vchart.setData(this.dayOption, true);
      
      
    },
    methods: {
      handleClick(tab, event) {
        this.$refs.vchart2.setData(this.dayOption, true);
      },
      //获取数据
      getList(){
        var d = {
          'dateType':this.value,
          'deviiceNo':this.nowDevice.deviceNo,
          'variableType':this.variableValue
        }
        
          findCurve(d).then(res => {
              if(res.code ==200){
                  if(this.value == 'DAY'){
                      this.dayOption.xAxis.data = this.dayData;
                  }else  if(this.value == 'MON'){
                        this.dayOption.xAxis.data = this.monthData;
                  }else  if(this.value == 'YEAR'){
                        this.dayOption.xAxis.data = this.yearData;
                  }
                  this.handleData(res.data)
                }else {
                  this.$message({ showClose: true, message: `获取失败,${res.message}`, type: 'warning'});
                }
          })
      },
      handleData(data){
        console.log("电流温度",data);
        this.dayOption.series = []
        var index = 0
        for(let key in data){
          //  console.log(key,data[key]);
            this.dayOption.series.push({
               name: key,
                data: [],
                type: 'line'
            });
          for(let k in data[key]){
            //  console.log(data[key][k]);
             this.dayOption.series[index].data.push(data[key][k])
          }
          index ++
        }
         this.$refs.vchart.setData(this.dayOption, true);
      },


    }
  };
</script>

<style lang="scss" scoped>
  .apphome .echart {
    width: 100%;
  }

  .apphome .search {
    display: flex;
  }

  .apphome .search .name {
    height: 30px;
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: #999;
    margin-bottom: 5px;
  }

  .apphome {
    padding: 15px;
    overflow-x: scroll;
    display: flex;
    margin-top: 1rem;
  }
</style>